export const COMPACT_MULTI_SELECT_STYLE_PROPS = {
  dropdownInnerWrapperClassName: 'min-w-0 flex-1 flex-nowrap items-center py-0',
  multiSelectDropdownClasses: 'min-w-0',
  selectedItemClassName: 'min-w-0 rounded-md py-1 -my-1 pl-2 pr-2 mr-1',
  selectedItemLabelClassName: 'min-w-0 truncate',
  remainingTriggerClassName: 'shrink-0 rounded-md py-1 -my-1 pl-2 pr-2',
} as const;
